import { Alert, Button, Form, Space, Typography } from 'antd'
import AuthorisedContainer from 'components/AuthorisedContainer'
import { PermissionSetMap } from 'constants/RBACConstants'
import React, { forwardRef, useCallback, useEffect,useState } from 'react'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { isUndefined } from 'lodash'
import { ToolConfigurationNotesOptInUsersAPI } from 'restAPI/ToolsIntegrationAPI'
import UserAPI from 'restAPI/UserAPI';

const ToolConfigNotesOptInUsersListSelection = forwardRef(({toolName},ref) => {
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();
    const [users, setUsers] = useState(undefined);


    useEffect(()=>{
        const { cancel, promise } = UserAPI.getAll(undefined);
        let cancelPromise = cancel;
        promise
            .then((usersList) => {
                setUsers(usersList)
            })
            .catch((err) => {
                console.log(err);
            })
        return () => cancelPromise();
    },[]);

    
    const fetchData = useCallback(async ()  => {
        try{
            let resData = await ToolConfigurationNotesOptInUsersAPI.getToolConfigurationNotesOptInUsers().promise;
            if (!isUndefined(resData)) {
                let toolConfigNotesOptInUsers = resData["TOOL_CONFIG_NOTES_USER_OPT_IN"]?.config;
                let toolOptInUsersData;
                try{
                    toolOptInUsersData = JSON.parse(toolConfigNotesOptInUsers);
                }
                catch(err){
                    console.log(err);
                    toolOptInUsersData = []
                }
                const optInUsersList = [...(toolOptInUsersData[toolName] || []).map((data)=>{
                    return data.id
                })] || []
                form.setFieldsValue({"optInUsersList": optInUsersList, "allToolOptInUsers": toolOptInUsersData})
            }
        } catch(err) {
            console.error(err)
        }
    }, [form, toolName])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])

    const fields = [{
        name: `optInUsersList`,
        label: "Opt-in users",
        type: FieldTypes.MULTI_SELECT,
        placeholder: "Opt-in users",
        permission: PermissionSetMap.UPDATE_SLA,
        required: false,
        options: users
    }]


    const onReset = useCallback(async() => {
        form.setFieldsValue({optInUsersList: []});
    },[form]);



    return (
        <Space direction="vertical" className="m-b-m">
            <Typography.Text>Select the {toolName} Configuration Notes opt-in users</Typography.Text>
            <Alert 
                description={
                    <Form 
                        form={form}
                        ref={ref}
                        style={{minWidth:400}} 
                        layout="vertical"
                    >
                        {generateFormFields(fields)}

                        <Form.Item className="text-right p-x-sm" >
                            <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                <Button type="primary" onClick={onReset}>Reset</Button>
                            </AuthorisedContainer>
                         </Form.Item>    
                    </Form>
                } 
            />
        </Space>
    )
})

export default ToolConfigNotesOptInUsersListSelection;